import { Grid, Typography, TextField, InputAdornment, IconButton } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { PersonalLoanCalculatorGridSizes } from '@src/types/Constants'
import { formatCurrency } from '@if/core/utils'
import { ComputeFundingResultDto } from '@src/types/ComputePersonalLoanFundingResultDto'

interface ClinicFeeDisplayProps {
  showClinicFee: boolean
  onToggleClinicFee: () => void
  calculatedRate?: ComputeFundingResultDto | null
  amountRequested: number | undefined
}

export const ClinicFeeDisplay = ({
  showClinicFee,
  onToggleClinicFee,
  calculatedRate,
  amountRequested,
}: ClinicFeeDisplayProps) => {
  const { t } = useTranslation()
  const getMerchantFees = () => {
    if (calculatedRate?.merchantFeeRate && amountRequested) {
      return formatCurrency((calculatedRate.merchantFeeRate / 100) * amountRequested)
    }
    return 0
  }
  return (
    <>
      <Grid size={PersonalLoanCalculatorGridSizes.COMMON}>
        <Typography variant="body2" gutterBottom>
          {t('calculator.clinicFee')}
        </Typography>
        <TextField
          slotProps={{
            input: {
              readOnly: true,

              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={onToggleClinicFee} edge="end" size="small">
                    {!showClinicFee ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
          value={!showClinicFee ? '••••' : calculatedRate ? getMerchantFees() : ''}
          fullWidth
          variant="outlined"
        />
      </Grid>

      {calculatedRate && calculatedRate.lenderFeeRate === 0 && (
        <Grid size={PersonalLoanCalculatorGridSizes.COMMON}>
          <Typography variant="body2" gutterBottom>
            {t('calculator.lenderFee')}
          </Typography>
          <TextField
            slotProps={{
              input: {
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <Typography component="span">%</Typography>
                  </InputAdornment>
                ),
              },
            }}
            value={calculatedRate.lenderFeeRate}
            fullWidth
            variant="outlined"
          />
        </Grid>
      )}
    </>
  )
}
